// TODO frha: Move the error component to be reusable across apps
import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  imports: [],
})
export class NotFoundComponent {}
